<template>
  <div class="col-12 row form-group">
    <div class="col-6">
      <!-- :type="$route.name.match('detail') ? 'datetime' : 'date'" -->
      <b-form-group label="Start Datetime" label-for="start_datetime">
        <date-picker
          id="start_datetime"
          v-model="startDate"
          :type="'date'"
          :format="
            $route.name.match('detail') ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
          "
        ></date-picker>
      </b-form-group>
    </div>
    <div class="col-6">
      <b-form-group label="End Datetime" label-for="end_datetime">
        <date-picker
          id="end_datetime"
          v-model="endDate"
          :type="'date'"
          :format="
            $route.name.match('detail') ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
          "
        ></date-picker>
      </b-form-group>
    </div>
    <!-- <div v-if="!$route.name.match('daily') && !$route.name.match('detail')" class="col-6">
      <b-form-group
        :label="$route.name.match('monthly') ? 'Month' : 'Day of Week'"
        label-for="select"
      >
        <v-select
          id="select"
          multiple
          v-model="range"
          :options="
            $route.name.match('monthly') ? $moment.months() : $moment.weekdays()
          "
        />
      </b-form-group>
    </div> -->
    <div
      v-if="
        typeof field.find((item) => item.field.match('sender')) !== 'undefined'
      "
      class="col-6"
    >
      <b-form-group label="Sender" label-for="sender">
        <input class="form-control" id="sender" v-model="sender" type="text" />
      </b-form-group>
    </div>

    <div class="col-12">
      <b-form-group label="Name" label-for="user">
        <!-- <v-select id="user" multiple v-model="user" :options="userList" /> -->
        <vue-select-sides
          id="user"
          style="height: 30vh"
          type="mirror"
          v-model="user"
          :list="userList"
        ></vue-select-sides>
      </b-form-group>
    </div>
  </div>
</template>

<script>
  import { requestService } from '../../../../_services';

  export default {
    props: {
      field: Array,
    },
    data() {
      return {
        startDate: null,
        endDate: null,
        user: [],
        userList: [],
        range: null,
        sender:""
      };
    },

    async mounted() {
      await this.getUser();
      // console.log(
      //   this.userList.map((item) => ({
      //     label: item,
      //     value: item,
      //   }))
      // );
    },
    methods: {
      async getUser() {
        let url = `/api/user/all`;
        const resData = await requestService.GetFetch('auth', url);
        const data = await resData.json();
        this.userList = data.data.map(
          ({ first_name: label, _id: value, ...rest }) => ({
            label,
            value,
            ...rest,
          })
        );
      },
      getFilter() {
        let object = {
          date_start: this.convertTimeToDate(this.startDate),
          date_end: this.convertTimeToDate(this.endDate),
          user_id: this.user.join(","),
        };
        if(this.$route.name.match('detail')){
          object['sender']=this.sender
        }
        return object;
      },
      convertTimeToDate(timeStamp) {
        if (timeStamp != null && timeStamp != '') {
          var date = new Date(timeStamp.getTime());
          let year = date.getFullYear();
          let month = date.getMonth() + 1;
          if (month < 10) {
            month = '0' + month;
          }
          let day = date.getDate();
          if (day < 10) {
            day = '0' + day;
          }
          let dateTime = year + '-' + month + '-' + day + ' 00:00:00';
          return dateTime;
        } else {
          return '';
        }
      },
    },
  };
</script>

<style>
  .vs__search {
    border: 0 !important;
  }
</style>
